import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-20 lg:py-32 bg-slate-50/60">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">
              <span className="h-px w-8 bg-magenta" />
              Întrebări frecvente
            </div>
            <h2 className="font-display mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
              Ce ne întreabă <span className="text-electric">clienții noi</span>.
            </h2>
            <p className="mt-4 text-slate-600">
              Nu vedeți răspunsul aici? Scrieți-ne direct și răspundem în 24h.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="space-y-2" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="bg-white border border-slate-200 rounded-2xl px-6 data-[state=open]:border-magenta/40"
                >
                  <AccordionTrigger className="font-display text-left text-base lg:text-lg font-semibold text-slate-900 hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed pb-5 text-[15px]">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
